//
//
//
export default {
  props: {
    model: {
      type: Object,
      required: true
    },
    prop: {
      type: String,
      required: true
    },
    onClickLink: {
      type: Function,
      required: true
    }
  }
};